import React, { useState, useEffect } from 'react';
import { AddIcon } from 'cokitchen-icons';
import useDashboardContext from 'contexts/dashboard.context';
import useEventDetailsContext from 'contexts/event-details.context';
import FundWalletModal from 'components/modals/fund-wallet-modal';
import TopUpSuccessModal from './top-up-success-modal';
import EventCreatedSuccessModal from './event-created-success-modal';
import { formatCurrency } from 'utils/functions';
import InsufficientTag from 'components/base/insufficient-tag';

const Topupwallet = () => {
  const { formData, setDisabled } = useEventDetailsContext();
  const [showTopSuccessModal, setShowTopSuccessModal] = useState(false);
  const [showEventCreationSuccessModal, setShowEventCreationSuccessModal] = useState(false);
  const [showFundWalletModal, setShowFundWalletModal] = useState(false);
  const { companyWalletDetails } = useDashboardContext();
  const balance = companyWalletDetails?.available_balance.toString() as string;

  useEffect(() => {
    setDisabled(Number(formData.budget) > Number(balance));
  }, [formData.budget]);
  return (
    <>
      <div className='flex flex-col w-[390px]'>
        <h4 className='text-[32px] text-[#2E3031] font-semibold mb-1'>Top-up event wallet</h4>
        <p className='text-[#6F7376] mb-8'>Kindly topup your wallet to proceed</p>
        <div className='bg-[#F7F7F7] rounded-md border border-[#F0EFEF] w-full h-[128px] flex flex-col justify-center items-center mb-10'>
          <p className='text-[#6F7376] mb-1 text-sm'>Your event total budget is</p>
          <p className='text-[10px] text-[#2E3031]'>
            NGN{' '}
            <span className='text-[32px] font-semibold'>
              {formatCurrency(formData.budget, {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
                style: 'decimal'
              })}
            </span>
          </p>
        </div>
        <div className='w-full py-3 px-4 rounded-md border border-[#E60A2B] flex justify-between items-center mb-2'>
          <div>
            <p className='text-sm text-[#2E3031] font-medium'>Food Court Wallet</p>
            <p className='text-[#6F7376] text-xs'>Balance: {formatCurrency(balance)}</p>
          </div>
          <div>
            <InsufficientTag insufficient={Number(formData.budget) > Number(balance)} />
          </div>
        </div>
        {Number(formData.budget) > Number(balance) && (
          <div
            className='cursor-pointer flex items-center gap-[2px] text-[#0080E5]'
            onClick={() => setShowFundWalletModal(true)}>
            <p className=' text-xs font-medium'>Fund wallet</p>
            <AddIcon className='w-4 h-4' />
          </div>
        )}
      </div>
      <TopUpSuccessModal
        isOpen={showTopSuccessModal}
        onClose={() => setShowTopSuccessModal(false)}
        setEventCreatedSuccessModal={() => setShowEventCreationSuccessModal(true)}
      />
      <EventCreatedSuccessModal
        isOpen={showEventCreationSuccessModal}
        onClose={() => setShowEventCreationSuccessModal(false)}
      />
      <FundWalletModal isOpen={showFundWalletModal} onClose={() => setShowFundWalletModal(false)} />
    </>
  );
};

export default Topupwallet;
